import urlcat from 'urlcat';

import { createClient } from '../client';

import { API_BASE_URL } from '../config';
import { USER_FORM } from '../config/endpoints';

const baseURL = urlcat(API_BASE_URL, USER_FORM);
const client = createClient(baseURL);

export default class GameAccountDeletion {
  static async checkStatus(data = {}) {
    return client.post('status', data);
  }

  static async eraseDataRequest(data = {}) {
    return client.post('delete', data);
  }
}
